var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS4G(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3657 18.8165C16.6802 19.5011 15.7704 19.8779 14.8027 19.8779C13.8349 19.8779 12.9251 19.5011 12.2397 18.8165L7.10486 13.6846C6.41986 13 6.04285 12.0903 6.04285 11.1231C6.04285 10.1558 6.41986 9.24657 7.10486 8.56151C7.7903 7.8769 8.70009 7.5001 9.66785 7.5001C10.6356 7.5001 11.5458 7.8769 12.2308 8.56151L14.8027 11.1323L21.904 4.03459C19.5839 2.05859 16.5807 0.857422 13.2911 0.857422C5.95036 0.857422 0 6.80443 0 14.141C0 21.4776 5.95036 27.4246 13.2911 27.4246C20.6318 27.4246 26.5839 21.4776 26.5839 14.141C26.5839 12.7678 26.3755 11.4437 25.9874 10.1974L17.3657 18.8165Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8028 17.4621C14.4931 17.4621 14.1846 17.3445 13.9492 17.1087L8.81439 11.9768C8.34312 11.5058 8.34312 10.7416 8.81439 10.2688C9.28566 9.79604 10.0503 9.79781 10.5233 10.2688L14.8046 14.5476L26.9394 2.41966C27.4107 1.94866 28.1753 1.94866 28.6483 2.41966C29.1214 2.89066 29.1196 3.65488 28.6483 4.12765L15.6582 17.1105C15.421 17.3445 15.1108 17.4621 14.8028 17.4621Z",
    fill: "#BEBEBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4G);
export default __webpack_public_path__ + "static/media/s4g.aa8a4ad3d0a97269c4f939ce31025842.svg";
export { ForwardRef as ReactComponent };